/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TotalAmount interface.
 */
export function instanceOfTotalAmount(value) {
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    return true;
}
export function TotalAmountFromJSON(json) {
    return TotalAmountFromJSONTyped(json, false);
}
export function TotalAmountFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amount': json['amount'],
    };
}
export function TotalAmountToJSON(json) {
    return TotalAmountToJSONTyped(json, false);
}
export function TotalAmountToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amount': value['amount'],
    };
}
